module.exports = __webpack_public_path__ + "static/Filtry_ciśnieniowe_gumowane-459697f2cfefc33fd823dfce5a1838f4.png";